import c from "moment";
import { IntervalState as p } from "@ancon/wildcat-types";
import a from "../time/getTimeSpanParts.mjs";
import { OutletMapKeyFormatter as d, OutletTimelineDayCount as O } from "./constants.mjs";
import f from "./getTimezoneAdjustedServiceInterval.mjs";
import "../date/getTimezoneUtcOffsetDifference.mjs";
import "../date/convertToSpecificTimezone.mjs";
import "./getServiceIntervalTimeSpanMoment.mjs";
function g(l) {
  let t = null;
  const { intervals: e, exception: n } = l;
  if (n) {
    const { state: r } = n;
    r || (t = n);
  } else {
    const r = e.sort(
      (i, o) => a(i.from).hours - a(o.from).hours
    ), [s] = r;
    return s;
  }
  return t;
}
function v(l, t, e) {
  var r, s;
  const n = [];
  if (t.exception) {
    if (t.exception.state === p.Opened) {
      const o = f(
        l,
        t.exception,
        e.utcOffset()
      ).openingTime;
      e.isBefore(o) && n.push({
        interval: t.exception,
        moment: o
      });
    }
  } else
    for (let i = 0; i < t.intervals.length; i += 1) {
      const o = t.intervals[i], u = f(
        l,
        o,
        e.utcOffset()
      ).openingTime;
      e.isBefore(u) && n.push({ interval: o, moment: u });
    }
  return n.length < 2 ? ((r = n[0]) == null ? void 0 : r.interval) ?? null : ((s = n.sort(
    // @ts-ignore TODO
    (i, o) => i.moment - e - (o.moment - e)
  )[0]) == null ? void 0 : s.interval) ?? null;
}
function K(l, t) {
  let e = null;
  const n = c(t).format(d), r = v(
    n,
    l[n],
    t
  );
  if (r && (e = f(
    n,
    r,
    t.utcOffset()
  ).openingTime), !e)
    for (let s = 1; s < O; s += 1) {
      const i = c(t).add(s, "d"), o = i.format(d), m = l[o], u = g(m);
      if (u) {
        e = f(
          o,
          u,
          i.utcOffset()
        ).openingTime;
        break;
      }
    }
  return e;
}
export {
  K as default
};
